import { render, staticRenderFns } from "./DetectionSetDelete.vue?vue&type=template&id=24589b66&"
import script from "./DetectionSetDelete.vue?vue&type=script&lang=js&"
export * from "./DetectionSetDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports